// Vilken modul hjälpen ska börja i, och vilka moduler användaren får se.
// Flyttad oförändrad från gamla HelpModal.js (2026-10-13) + koppling till
// instruktionerna (register.json: hjalpnyckel och vag).

// Mappar help-keys (slug i public/help/modules.json) till backend module-keys
// (effectiveModuleKeySet i Layout.js). '__admin_only__' = bara admins.
export const HELP_KEY_TO_MODULE_KEY = {
  projektinformation: 'projects', krav: 'projects', dagbok: 'projects', dokument: 'projects',
  tidplan: 'projects', ata: 'projects', betalplan: 'projects', todo: 'projects', budget: 'projects',
  inkop: 'projects', kommunikation: 'projects', 'projekt-kanai': 'projects', bilder: 'projects',
  mangdavstamning: 'projects', 'project-map': 'project_map',
  inskrivningar: 'inskrivningar', qa: 'qa_controls', insight: 'insight', tender: 'tenders',
  ledningssystem: 'management_system', 'mgmt-goals': 'mgmt.goals', 'mgmt-review': 'mgmt.review',
  'mgmt-stakeholders': 'mgmt.stakeholders', 'mgmt-iso-matrix': 'mgmt.iso_matrix',
  'mgmt-deviations': 'mgmt.deviations', 'mgmt-risk': 'mgmt.risk', 'mgmt-improvements': 'mgmt.improvements',
  'mgmt-audits': 'mgmt.audits', 'mgmt-legal': 'mgmt.legal',
  'mgmt-customer-requirements': 'mgmt.customer_requirements', 'mgmt-suppliers': 'mgmt.suppliers',
  'mgmt-competency': 'mgmt.competency', 'mgmt-training': 'mgmt.training',
  'mgmt-employee-reviews': 'mgmt.employee_reviews', 'mgmt-onboarding': 'mgmt.onboarding',
  'mgmt-environment': 'mgmt.environment', 'mgmt-work-environment': 'mgmt.work_environment',
  'mgmt-crisis': 'mgmt.crisis', 'mgmt-documents': 'mgmt.documents',
  revisions: 'revisions', 'revisions-oversikt': 'revisions', 'revisions-flow': 'revisions',
  'revisionsmallar-import': 'revisions',
  kontakter: 'contacts', orgplan: 'orgplan', resurser: 'resource_planning', moten: 'meetings',
  assessments: 'assessments', hrm: 'hrm', 'cv-generator': 'cv_generator',
  'reference-projects': 'reference_projects', 'signature-generator': 'signature_generator',
  ekonomi: 'finance_dashboard', dashboard: 'dashboard', 'management-dashboard': 'management_dashboard',
  'finance-dashboard': 'finance_dashboard', 'insight-analytics': 'insight_analytics',
  issues: 'issues', contracts: 'contracts', inbox: 'inbox', knowledge: 'kanai', suppliers: 'supplier_api',
  bim: 'bim_viewer', training: 'onboarding',
  'time-reporting': 'time_reporting', purchasing: 'purchasing', kancalc: 'kancalc', calcreview: 'kancalc',
  rutinhantering: 'routine_management', 'open-books': 'open_books', payroll: 'payroll',
  'ek-bibliotek': 'ek_bibliotek',
  ia: 'ia_system', skyddsronder: 'skyddsronder', fleet: 'fleet', klimat: 'klimat',
  'sakerhet-backup': '__admin_only__', acc: '__admin_only__',
};

export function filtreraPaBehorighet(moduler, accessSet, isAdmin) {
  if (isAdmin) return moduler;
  if (!accessSet || !accessSet.size) return moduler;
  return moduler.filter((m) => {
    const mal = HELP_KEY_TO_MODULE_KEY[m.key];
    if (mal === '__admin_only__') return false;
    if (mal) return accessSet.has(mal);
    return accessSet.has(m.key) || accessSet.has(m.key.replace(/-/g, '_'));
  });
}

// Projektflikens #hash → help-key (gamla modulbeskrivningarna).
const HASH_TILL_HJALP = {
  info: 'projektinformation', krav: 'krav', dagbok: 'dagbok', dokument: 'dokument', bilder: 'bilder',
  tidplan: 'tidplan', ata: 'ata', betalplan: 'betalplan', todo: 'todo', budget: 'budget', inkop: 'inkop',
  kommunikation: 'kommunikation', inskrivningar: 'inskrivningar', 'p-ai': 'projekt-kanai',
  revisions: 'revisions', 'revisions-oversikt': 'revisions-oversikt', 'revisions-flow': 'revisions-flow',
  'rev-oversikt': 'revisions-oversikt', 'rev-flow': 'revisions-flow', moten: 'moten', meetings: 'moten',
  ekonomi: 'ekonomi', finance: 'ekonomi', dashboard: 'dashboard', 'sakerhet-backup': 'sakerhet-backup',
  'revisionsmallar-import': 'revisionsmallar-import', mangdavstamning: 'mangdavstamning',
};

// Projektflikens #hash → instruktion (flikarna i ProjectDetails.js).
const HASH_TILL_INSTRUKTION = {
  dagbok: 'dagbok', bilder: 'bildbank', tidplan: 'tidplan', 'fraga-svar': 'fraga-svar', todo: 'arenden',
  inkop: 'inkop', skyddsronder: 'skyddsronder', schaktrond: 'saker-schakt', kommunikation: 'inkorg',
  inskrivningar: 'inskrivning', budget: 'avstamning-prognos', bak: 'avstamning-prognos',
  prognos: 'avstamning-prognos', lopande: 'lopande-rakning',
};

// Sökväg → help-key, samma regler som gamla hjälpen.
const VAG_TILL_HJALP = [
  ['/project-map', 'project-map'], ['/ai', 'projekt-kanai'], ['/tenders', 'tender'],
  ['/insight-analytics', 'insight-analytics'], ['/insight', 'insight'], ['/meetings', 'moten'],
  ['/finance-dashboard', 'finance-dashboard'], ['/finance', 'ekonomi'], ['/qa/', 'qa'],
  ['/purchasing', 'purchasing'], ['/inbox', 'inbox'], ['/accept-invite', 'inskrivningar'],
  ['/contacts/org', 'orgplan'], ['/orgplan', 'orgplan'], ['/contacts', 'kontakter'],
  ['/revisions', 'revisions'], ['/resource-planning', 'resurser'], ['/issues', 'issues'],
  ['/contracts', 'contracts'], ['/suppliers', 'suppliers'], ['/time-reporting', 'time-reporting'],
  ['/training', 'training'], ['/knowledge', 'knowledge'], ['/management-dashboard', 'management-dashboard'],
  ['/management-system', 'ledningssystem'], ['/ek-bibliotek', 'ek-bibliotek'], ['/assessments', 'assessments'],
  ['/bim', 'bim'], ['/kancalc', 'kancalc'], ['/calcreview', 'calcreview'], ['/rutinhantering', 'rutinhantering'],
  ['/open-books', 'open-books'], ['/payroll', 'payroll'], ['/hrm', 'hrm'], ['/cv-generator', 'cv-generator'],
  ['/reference-projects', 'reference-projects'], ['/signature-generator', 'signature-generator'],
  ['/ia', 'ia'], ['/skyddsronder', 'skyddsronder'], ['/fleet', 'fleet'], ['/klimat', 'klimat'], ['/acc', 'acc'],
];

function hjalpnyckelForSida(beskrivningar, vag, hash) {
  const p = (vag || '').toLowerCase();
  const h = (hash || '').replace('#', '');
  const finns = (k) => beskrivningar.some((m) => m.key === k);
  if (h && HASH_TILL_HJALP[h] && finns(HASH_TILL_HJALP[h])) return HASH_TILL_HJALP[h];
  if (p === '/' || p === '/dashboard' || p === '/home') return finns('dashboard') ? 'dashboard' : null;
  const traff = VAG_TILL_HJALP.find(([prefix]) => p.startsWith(prefix));
  if (traff && finns(traff[1])) return traff[1];
  if ((p === '/projects' || /\/projects\/.+/.test(p)) && finns('projektinformation')) return 'projektinformation';
  const inne = beskrivningar.find((m) => p.includes(m.key.toLowerCase()));
  return inne ? inne.key : null;
}

/**
 * Var hjälpen börjar: { typ: 'instruktion' | 'beskrivning', nyckel } eller null.
 * Ordning: projektflikens instruktion → instruktion vars menyadress matchar →
 * help-key (gamla reglerna) med instruktion → help-key som beskrivning →
 * senast valda → första instruktionen.
 */
export function valjStart({ instruktioner, beskrivningar, vag, hash, senast }) {
  const p = (vag || '').toLowerCase();
  const h = (hash || '').replace('#', '');
  const instr = (n) => instruktioner.find((i) => i.nyckel === n);
  if (/^\/projects\/\d+/.test(p) && h && HASH_TILL_INSTRUKTION[h] && instr(HASH_TILL_INSTRUKTION[h])) {
    return { typ: 'instruktion', nyckel: HASH_TILL_INSTRUKTION[h] };
  }
  const viaVag = instruktioner
    .filter((i) => i.vag && i.vag !== '/projects' && p.startsWith(i.vag.toLowerCase()))
    .sort((a, b) => b.vag.length - a.vag.length)[0];
  if (viaVag) return { typ: 'instruktion', nyckel: viaVag.nyckel };
  const hjalp = hjalpnyckelForSida(beskrivningar, vag, hash);
  if (hjalp) {
    const viaHjalp = instruktioner.find((i) => i.hjalpnyckel === hjalp);
    if (viaHjalp) return { typ: 'instruktion', nyckel: viaHjalp.nyckel };
    return { typ: 'beskrivning', nyckel: hjalp };
  }
  if (senast && senast.nyckel) {
    const finns = senast.typ === 'instruktion' ? instr(senast.nyckel) : beskrivningar.some((m) => m.key === senast.nyckel);
    if (finns) return senast;
  }
  if (instruktioner[0]) return { typ: 'instruktion', nyckel: instruktioner[0].nyckel };
  if (beskrivningar[0]) return { typ: 'beskrivning', nyckel: beskrivningar[0].key };
  return null;
}
